// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-flow[data-v-abb58098]{padding-bottom:98px;background-image:url(/images/hzc/home/bg-flow.png);background-size:cover;background-position:center center}.section-flow .title-section[data-v-abb58098]{padding:78px 0;font-weight:normal}.section-flow .img-flow[data-v-abb58098]{display:block;width:1082px;margin:0 auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
